import { BlankLayout } from '@/components/layouts';

export default {
  path: '/activity',
  name: 'Activity',
  component: BlankLayout,
  meta: { module: '活动汇总' },
  children: [
    {
      path: '/activity/gift',
      name: 'Activity.Gift',
      component: () => import(/* webpackChunkName: 'gift' */ '@/views/gift/GiftAndInvite.vue'),
      meta: { title: '新用户礼包_端外', titleAlias: '新用户礼包', hideBanner: true },
    },
    {
      path: '/activity/invite',
      name: 'Activity.Gift.Invite',
      component: () => import(/* webpackChunkName: 'gift-invite' */ '@/views/gift/GiftAndInvite.vue'),
      meta: { title: '邀请活动_端外', titleAlias: '邀请活动', hideBanner: true },
    },
    {
      path: '/activity/app/gift',
      name: 'Activity.App.Gift',
      component: () => import(/* webpackChunkName: 'app-gift' */ '@/views/gift/Gift.vue'),
      meta: { title: '新用户礼包', titleAlias: '新用户礼包', hideBanner: true },
    },
    {
      path: '/activity/app/invite',
      name: 'Activity.App.Invite',
      component: () => import(/* webpackChunkName: 'app-invite' */ '@/views/gift/InviteActivity.vue'),
      meta: { title: '邀请活动', titleAlias: '邀请有礼', hideBanner: true },
    },
    {
      path: '/activity/app/past/:id',
      name: 'Activity.App.Invite.Past',
      component: () => import(/* webpackChunkName: 'app-invite-past' */ '@/views/gift/InviteActivityPast.vue'),
      meta: { title: '往期活动详情', titleAlias: '邀请有礼', hideBanner: true },
    },
    {
      path: '/activity/app/list',
      name: 'Activity.App.Invite.Past.List',
      component: () => import(/* webpackChunkName: 'app-invite-past-list' */ '@/views/gift/InviteActivityListPast.vue'),
      meta: { title: '查看往期活动', titleAlias: '往期活动', hideBanner: true },
    },
    {
      path: '/activity/contribute/introduce',
      name: 'Activity.Contribute.Introduce',
      component: () => import(/* webpackChunkName: 'app-invite-past-list' */ '@/views/activity/contribute/Introduce.vue'),
      meta: { title: '投稿奖励页', titleAlias: '投稿奖励页', hideBanner: true },
    },
    {
      path: '/activity/free-trail',
      alias: '/free-trail', // 兼容旧版网页链接
      name: 'Free.Trail',
      component: () => import(/* webpackChunkName: 'free-trail' */ '@/views/activity/free-trail/index.vue'),
      meta: { title: '3天免费试用', hideBanner: true },
    },
    {
      path: '/activity/free-trail/apply',
      alias: '/free-trail/apply', // 兼容旧版网页链接
      name: 'Free.Trail.Apply',
      component: () => import(/* webpackChunkName: 'free-trail-result' */ '@/views/activity/free-trail/ApplySuccess.vue'),
      meta: { title: '3天免费试用_申请成功', hideBanner: true },
    },
    {
      path: '/activity/introduce',
      name: 'Activity.Introduce',
      component: () => import(/* webpackChunkName: 'introduce' */ '@/views/activity/introduce/index.vue'),
      meta: { title: '官网介绍页', hideBanner: true },
    },
    {
      path: '/activity/v2-introduce',
      name: 'Activity.V2.Introduce',
      component: () => import(/* webpackChunkName: 'v2-introduce' */ '@/views/activity/v2Introduce/index.vue'),
      meta: { title: '同户型方案免费领' },
    },
    {
      path: '/activity/coupon-center',
      name: 'Activity.Coupon.Center',
      component: () => import(/* webpackChunkName: 'coupon-center' */ '@/views/activity/coupon-center/index.vue'),
      meta: { title: '领券中心', hideBanner: true },
    },
  ],
};
